import { ConfigState } from '../publicshare/publicformwhitelabel/PublicFormWhitelabel';

export const customCss = (config: ConfigState | null | undefined): string => {
  if (!config) return null;

  return `
    #publicshare-header-wrapper {
      background-color: ${config.brandColor};
    }

    .light-theme #publicshare-header .ui.button.primary {
      background-color: ${config.primaryButtonColor};
      color: ${config.primaryButtonTextColor};
    }

    .light-theme #publicshare-header .ui.button.primary:hover{
      opacity: 0.9;
    }

    .light-theme #publicshare-header .ui.button.primary:focus {
      background-color: ${config.primaryButtonColor};
    }

    .light-theme #publicshare-header .ui.button.secondary {
      background-color: ${config.secondaryButtonColor};
      color: ${config.secondaryButtonTextColor};
    }

    .light-theme #publicshare-header .ui.button.secondary:hover {
      opacity: 0.9;
    }

    .light-theme #publicshare-header .ui.button.secondary:focus {
      background-color: ${config.secondaryButtonColor};
    }

    .light-theme #publicshare-header .ui.button.form-action-button > .text {
      color: ${config.tertiaryButtonTextColor};
    }

    .light-theme #publicshare-header .ui.button.form-action-button > .text:hover {
      opacity: 0.9;
    }

    .light-theme #publicshare-header .ui.button.form-action-button .icon {
      color: ${config.tertiaryButtonTextColor};
    }

    .light-theme #publicshare-header .right.menu .last-saved {
      color: ${config.tertiaryButtonTextColor};
    }

    .light-theme .ui.popup.save-public-form .button.primary.save-public-form-confirm {
      background-color: ${config.primaryButtonColor};
      color: ${config.primaryButtonTextColor};
    }

    .light-theme .ui.popup.save-public-form .button.primary.save-public-form-confirm:hover {
      opacity: 0.9;
    }

    .light-theme .ui.modal.confirm-submit-public-form .ui.button.primary {
      background-color: ${config.primaryButtonColor};
      color: ${config.primaryButtonTextColor};
    }

    .light-theme .ui.modal.confirm-submit-public-form .ui.button.primary:hover {
      opacity: 0.9;
    }

    .light-theme .ui.modal.confirm-submit-public-form .ui.button.secondary {
      background-color: ${config.secondaryButtonColor};
      color: ${config.secondaryButtonTextColor};
    }

    .light-theme .ui.modal.confirm-submit-public-form .ui.button.secondary:hover {
      opacity: 0.9;
    }

    .light-theme .ui.modal.confirm-submit-public-form .ui.button.primary.loading {
      color: transparent;
    }

    .light-theme .ui.popup.save-public-form .ui.button.primary.loading {
      color: transparent;
    }

    .light-theme #publicshare-header .ui.button.secondary.loading {
      color: transparent;
    }

    .light-theme .list-view .tab-panel .tab-view #section-view::before {
      background: ${config.brandColor};
    }
  `;
};
